export enum Routes {
  Home = "/",
  Admin = "/admin",
  AdminAddEmployees = "/admin/add-employees",
  Educations = "/utbildning",
  EducationsBase = "/utbildning/*",
  Account = "/konto",
  MyCertificates = "/mina-certifikat",
  ReferralLanding = "/referral-landing",
  Questions = "fragor",
  Theory = "teori",
  Practice = "praktik",
  Certificate = "certifikat",
  Documents = "dokument",
  Any = "*",
  NotFound = "/not-found",
  /** UI showroom — dev and staging only (see UIElements page) */
  UIElements = "/ui-elements",
}

export function isUiElementsPath(pathname: string): boolean {
  return pathname === Routes.UIElements;
}

export const RouteNames = {
  Education: {
    Base: "/",
    Course: "/:courseId",
    Questions: `/:courseId/${Routes.Questions}`,
    Theory: `/:courseId/${Routes.Theory}`,
    Practice: `/:courseId/${Routes.Practice}`,
    Certificate: `/:courseId/${Routes.Certificate}`,
    Documents: `/:courseId/${Routes.Documents}`,
  },
};
